import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/pages/Home.vue'
import Login from '@/pages/Login.vue';
import Register from '@/pages/Register.vue';
import Profile from '@/pages/Profile.vue';
import Accounts from '@/pages/Accounts.vue';
import ClinicalCase from '@/pages/ClinicalCase.vue';
import Forum from '@/pages/Forum.vue';
import ForumDetail from '@/pages/ForumDetail.vue';
import Presentation from '@/pages/Presentation.vue';
import CreatePresentation from '@/pages/presentations/CreatePresentation';
import ShowPresentation from '@/pages/presentations/ShowPresentation';
import EditPresentation from '@/pages/presentations/EditPresentation';
import Library from '@/pages/Library.vue';
import LibraryCreate from '@/pages/library/LibraryCreate';
import Meeting from '@/pages/Meeting.vue';
import ClinicalCaseShow from '@/pages/clinicalcase/ClinicalCaseShow';
import CreateClinicalCase from '@/pages/clinicalcase/CreateClinicalCase';
import UpdateClinicalCase from '@/pages/clinicalcase/UpdateClinicalCase';
import LibraryShow from '@/pages/library/LibraryShow';
import LibraryEdit from '@/pages/library/LibraryEdit';
import DicomPage from '@/pages/clinicalcase/DicomPage';
import LinkedinPage from '@/pages/Linkedin';
import CreateMeeting from '@/pages/meeting/CreateMeeting';
import ShowMeeting from '@/pages/meeting/ShowMeeting';
import ShowOldMeeting from '@/pages/meeting/ShowOldMeeting';
import EditMeeting from '@/pages/meeting/EditMeeting';
import StaticPage from '@/pages/StaticPage';
import RequestResetPassword from '@/pages/password/RequestResetPassword';
import ResetPassword from '@/pages/password/ResetPassword';
import TestPage from '@/pages/TestPage';
import DraftClinicalCase from '@/pages/clinicalcase/DraftClinicalCase';
import AssistenzaPage from '@/pages/AssistenzaPage.vue';
const routes = [
    { path: '/home', redirect: '/dashboard' },
    { path: '/login', redirect: '/' },

    {
        path: '/password-recovery',
        component: RequestResetPassword,
        name: "RequestResetPassword",
    },
    {
        path: '/reset-password/:token',
        component: ResetPassword,
        name: "ResetPassword",
        props: true
    },
    {
        path: '/neurohub/:slug',
        component: StaticPage,
        name: "StaticPage",
        props: true
    },
    {
        path: '/test/result/:id',
        component: TestPage,
        name: "TestPage",
        props: true
    },
    {
        path: '/dashboard',
        component: Home,
        name: "Dashboard",
        meta: {
            auth: true
        }
    },
    {
        path: '/',
        component: Login,
        name: "Login",
    },
    { path: '/register', component: Register, name: "Register" },
    {
        path: '/profile',
        component: Profile,
        name: "Profile",
        meta: {
            auth: true
        }
    },
    {
        path: '/accounts',
        component: Accounts,
        meta: {
            auth: true
        }
    },
    {
        path: '/casi-clinici',
        component: ClinicalCase,
        meta: {
            auth: true
        }
    },
    {
        path: '/casi-clinici/bozze',
        component: DraftClinicalCase,
        meta: {
            auth: true
        }
    },
    {
        path: '/casi-clinici/concludi-caso/:slug',
        component: CreateClinicalCase,
        meta: {
            auth: true
        },
    },
    {
        path: '/casi-clinici/nuovo-caso-clinico',
        component: CreateClinicalCase,
        meta: {
            auth: true
        }
    },
    {
        path: '/casi-clinici/show/:slug',
        component: ClinicalCaseShow,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: '/casi-clinici/update/:slug',
        component: UpdateClinicalCase,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: '/casi-clinici/visualizzatore-dicom/:id',
        component: DicomPage,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: '/post/request/share',
        component: LinkedinPage,
        meta: {
            auth: true
        },
    },
    {
        path: '/forum',
        component: Forum,
        meta: {
            auth: true
        }
    },
    {
        path: '/forum/:slug',
        component: ForumDetail,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: '/forum/show/:slug',
        component: ForumDetail,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: '/presentation',
        component: Presentation,
        meta: {
            auth: true
        }
    },
    {
        path: '/presentation/create',
        component: CreatePresentation,
        meta: {
            auth: true
        },
    },
    {
        path: '/presentation/show/:slug',
        component: ShowPresentation,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: '/presentation/edit/:slug',
        component: EditPresentation,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: '/library',
        component: Library,
        meta: {
            auth: true
        }
    },
    {
        path: '/library/show/:slug',
        component: LibraryShow,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: '/library/edit/:slug',
        component: LibraryEdit,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: '/library/create',
        component: LibraryCreate,
        meta: {
            auth: true
        }
    },
    {
        path: '/meeting',
        component: Meeting,
        meta: {
            auth: true
        }
    },
    {
        path: '/meeting/create',
        component: CreateMeeting,
        meta: {
            auth: true
        }
    },
    {
        path: '/meeting/show/:slug',
        component: ShowMeeting,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: "/assistenza",
        component: AssistenzaPage,
    },
    {
        path: '/meeting/edit/:slug',
        component: EditMeeting,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: '/meeting/registration/:slug',
        component: ShowOldMeeting,
        meta: {
            auth: true
        },
        props: true
    },
    {
        path: '/:slug',
        component: StaticPage,
        props: true
    },
]

const router = createRouter({
    history: createWebHistory("/"),
    routes
})

export default router